import { mapGetters, mapMutations } from 'vuex';

export default {
  computed: {
    ...mapGetters([
      'modalState',
      'modalContent',
      'modalCloseOnClick',
      'modalShowClose',
      'modalCloseOnPressEscape',
      'modalProps',
      'modalSize',
      'modalClass',
    ]),

    content() {
      return typeof this.modalContent === 'function' ? this.modalContent() : this.modalContent;
    },

    active: {
      get() {
        return this.modalState;
      },
      set(value) {
        this.toggle(value);
      },
    },
  },

  methods: {
    ...mapMutations({
      toggle: 'TOGGLE_MODAL',
      unsetModalContent: 'UNSET_MODAL_CONTENT',
    }),

    onClose() {
      this.toggle(false);
      this.unsetModalContent();
    },
  },
};



// WEBPACK FOOTER //
// ./src/app/components/modal/modal.js